<svg
  xmlns="http://www.w3.org/2000/svg"
  class="h-6 w-6"
  fill="currentColor"
  viewBox="0 0 24 24"
>
  <rect x="6" y="6" width="12" height="12" rx="2" />
</svg>
